import { PRODUCT_NAME } from '@classgo/shared/brand';

/**
 * Strings of the staff console on top of the kit's: navigation, schools, contracts with the guided
 * copy per field, owners, act-as, the team. Spanish of Colombia, institutional register.
 */
export const staffMessages = {
  'app.name': `${PRODUCT_NAME} · Consola`,
  'nav.main': 'Consola',
  'nav.tenants': 'Colegios',
  'nav.team': `Equipo ${PRODUCT_NAME}`,
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.optional': 'Opcional',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.none': '—',
  'shell.tenantNotice.title': `Esta es la consola del equipo ${PRODUCT_NAME}`,
  'shell.tenantNotice.body':
    'Su cuenta pertenece a un colegio. Use la aplicación del colegio para ingresar.',
  'tenants.title': 'Colegios',
  'tenants.new': 'Nuevo colegio',
  'tenants.caption': 'Colegios registrados',
  'tenants.empty.title': 'Aún no hay colegios',
  'tenants.empty.body':
    'Cree el primero con el asistente: colegio, contrato y rectoría en tres pasos.',
  'tenants.column.name': 'Colegio',
  'tenants.column.status': 'Estado',
  'tenants.column.created': 'Creado',
  'tenants.column.country': 'País',
  'tenant.status.active': 'Activo',
  'tenant.status.suspended': 'Suspendido',
  'tenant.demo': 'Demo',
  'tenant.actions.actAs': `Entrar como ${PRODUCT_NAME}`,
  'tenant.actions.suspend': 'Suspender',
  'tenant.actions.reactivate': 'Reactivar',
  'tenant.actions.edit': 'Editar datos',
  'tenant.tabs.label': 'Secciones del colegio',
  'tenant.tabs.overview': 'Resumen',
  'tenant.tabs.contracts': 'Contratos',
  'tenant.tabs.people': 'Rectoría',
  'tenant.tabs.users': 'Usuarios',
  'tenant.users.title': 'Personas del colegio',
  'tenant.users.caption': 'Personas con acceso o invitación',
  'tenant.users.counts':
    '{owners} rectoría · {staff} personal · {teachers} docentes · {students} estudiantes · {guardians} acudientes',
  'tenant.users.empty': 'Todavía nadie con acceso.',
  'tenant.users.column.name': 'Persona',
  'tenant.users.column.roles': 'Rol',
  'tenant.users.column.account': 'Acceso',
  'tenant.users.account.yes': 'Con cuenta',
  'tenant.users.account.no': 'Sin cuenta',
  'tenant.users.firstLoginPending': 'Pendiente de primer ingreso',
  'tenant.users.invitation.pending': 'Invitación pendiente',
  'tenant.users.invitation.accepted': 'Con cuenta',
  'tenant.users.invitation.expired': 'Invitación vencida',
  'tenant.users.invitation.revoked': 'Invitación reemplazada',
  'tenant.users.role.SCHOOL_OWNER': 'Rectoría',
  'tenant.users.role.SCHOOL_STAFF': 'Personal',
  'tenant.users.role.TEACHER': 'Docente',
  'tenant.users.role.STUDENT': 'Estudiante',
  'tenant.users.role.GUARDIAN': 'Acudiente',
  'tenant.health.people': 'Personas',
  'tenant.health.people.value':
    '{students} estudiantes · {guardians} acudientes · {teachers} docentes',
  'tenant.health.setup': 'Puesta en marcha',
  'tenant.health.setup.ready': 'Lista para el primer día',
  'tenant.health.setup.value': '{percent}% · {pending} pasos pendientes',
  'tenant.courtesy.ending': 'Cortesía termina en {days} días',
  'tenant.courtesy.ended': 'Cortesía terminó el {date}',
  'tenant.health.title': 'Salud del colegio',
  'tenant.health.users': 'Usuarios',
  'tenant.health.sedes': 'Sedes',
  'tenant.health.groups': 'Grupos',
  'tenant.health.activeContract': 'Contrato activo',
  'tenant.health.none': 'Ninguno',
  'tenant.health.lastActivity': 'Última actividad',
  'tenant.health.never': 'Sin actividad todavía',
  'tenant.health.lastImport': 'Última importación',
  'tenant.health.noImport': 'Sin importaciones todavía',
  'tenant.health.importRows': 'filas',
  'tenant.health.importErrors': 'con error',
  'tenant.health.import.queued': 'en cola',
  'tenant.health.import.running': 'en curso',
  'tenant.health.import.done': 'completada',
  'tenant.health.import.failed': 'con fallas',
  'tenant.identity.title': 'Datos del colegio',
  'tenant.sedes.title': 'Sedes',
  'tenant.sedes.main': 'principal',
  'tenant.field.name': 'Nombre del colegio',
  'tenant.field.name.help':
    'Como lo conocen las familias. Aparece en la aplicación y en las comunicaciones.',
  'tenant.field.legalName': 'Razón social',
  'tenant.field.legalName.help': 'Como aparece en el RUT. Necesaria para facturar.',
  'tenant.field.nit': 'NIT',
  'tenant.field.nit.help': 'Con dígito de verificación, por ejemplo 900123456-8.',
  'tenant.field.daneCode': 'Código DANE',
  'tenant.field.daneCode.help':
    'El código del establecimiento en el DANE; se usa en el reporte SIMAT.',
  'tenant.field.mainSedeName': 'Nombre de la sede principal',
  'tenant.field.mainSedeName.help':
    'Todo colegio empieza con una sede; las demás se agregan desde la aplicación del colegio.',
  'tenant.field.isDemo': 'Colegio de demostración',
  'tenant.field.isDemo.help': 'Los colegios demo no se facturan y sus datos se pueden regenerar.',
  'tenant.field.defaults': 'Colombia · COP · es-CO · America/Bogota',
  'tenant.field.defaults.help':
    'Valores por defecto para Colombia. Otros países llegarán con su paquete.',
  'tenant.saved': 'Datos guardados.',
  'tenant.suspended': 'Colegio suspendido: sus usuarios no podrán ingresar.',
  'tenant.reactivated': 'Colegio reactivado.',
  'tenant.editTitle': 'Editar datos del colegio',
  'contract.title': 'Contratos',
  'contract.new': 'Nuevo contrato',
  'contract.edit': 'Editar contrato',
  'contract.caption': 'Contratos del colegio',
  'contract.empty': 'Este colegio no tiene contrato. Sin contrato no hay facturación.',
  'contract.column.period': 'Vigencia',
  'contract.column.cycle': 'Ciclo',
  'contract.column.fees': 'Tarifas',
  'contract.column.courtesy': 'Cortesía',
  'contract.column.status': 'Estado',
  'contract.status.active': 'Vigente',
  'contract.status.ended': 'Terminado',
  'contract.cycle.monthly': 'Mensual',
  'contract.cycle.annual': 'Anual',
  'contract.open': 'sin fecha de fin',
  'contract.perStudent': 'por estudiante',
  'contract.mentoria': 'MentorIA',
  'contract.noCourtesy': 'Sin cortesía',
  'contract.field.startsOn': 'Inicio del contrato',
  'contract.field.startsOn.help': `Desde este día el colegio usa ${PRODUCT_NAME}. Los cobros empiezan al terminar la cortesía, si la hay.`,
  'contract.field.endsOn': 'Fin del contrato',
  'contract.field.endsOn.help': 'Déjelo vacío si el contrato se renueva automáticamente.',
  'contract.field.billingCycle': 'Ciclo de facturación',
  'contract.field.billingCycle.help':
    'Mensual: una factura cada mes. Anual: una sola factura con el descuento acordado.',
  'contract.field.platformFee': 'Tarifa de plataforma (COP)',
  'contract.field.platformFee.help':
    'Cargo fijo por colegio en cada periodo, sin importar cuántos estudiantes tenga.',
  'contract.field.pricePerStudent': 'Precio por estudiante (COP)',
  'contract.field.pricePerStudent.help': 'Cargo por cada estudiante activo en el periodo.',
  'contract.field.discountPercent': 'Descuento (%)',
  'contract.field.discountPercent.help':
    'Sobre el total del periodo. Úselo para pago anual o acuerdos especiales.',
  'contract.field.courtesyStartsOn': 'Cortesía desde',
  'contract.field.courtesyEndsOn': 'Cortesía hasta',
  'contract.field.courtesy.help':
    'Periodo sin cobro. El colegio usa todo desde el primer día; la facturación empieza al terminar la cortesía.',
  'contract.field.mentoriaEnabled': 'MentorIA habilitado',
  'contract.field.mentoriaEnabled.help':
    'El tutor de IA para estudiantes. Se vende por estudiante y se cobra por anticipado.',
  'contract.field.mentoriaPricePerStudent': 'Precio de MentorIA por estudiante (COP)',
  'contract.field.mentoriaPricePerStudent.help':
    'Lo que ClassGO le factura al colegio por cada estudiante activo al mes. Déjelo vacío para usar el precio de lista.',
  'contract.field.mentoriaFamilyPrice': 'Precio a las familias por mes (COP)',
  'contract.field.mentoriaFamilyPrice.help':
    'Lo que el colegio le cobra a cada familia por mes activado. Vacío: el mismo precio por estudiante. 0: el colegio lo asume y no se genera cobro.',
  'contract.field.mentoriaMonthlyQuota': 'Preguntas por estudiante al mes',
  'contract.field.mentoriaMonthlyQuota.help':
    'Cupo mensual de cada estudiante; al agotarlo MentorIA deja de responder hasta el mes siguiente. Vacío: 40.',
  'contract.field.mentoriaModelId': 'Modelo',
  'contract.field.mentoriaModelId.help':
    'El modelo de Claude que responde en este colegio. El predeterminado es el más económico.',
  'contract.model.default': 'Predeterminado (Claude Haiku 4.5)',
  'contract.field.notes': 'Notas',
  'contract.field.notes.help':
    'Lo que el equipo debe saber: quién negoció, condiciones especiales.',
  'contract.field.status': 'Estado del contrato',
  'contract.created': 'Contrato creado.',
  'contract.updated': 'Contrato actualizado.',
  'owner.title': 'Rectoría',
  'owner.intro':
    'La rectoría es la cuenta dueña del colegio: tiene todos los permisos y crea al resto del equipo desde la aplicación del colegio.',
  'owner.invite': 'Invitar rectoría',
  'owner.another': 'Invitar otra rectoría',
  'owner.current.title': 'Rectoría actual',
  'owner.current.caption': 'Personas con el rol de rectoría en este colegio',
  'owner.current.empty': 'Este colegio todavía no tiene rectoría.',
  'owner.current.pendingHelp':
    'La contraseña temporal llegó por correo y vence 7 días después de creada la cuenta. El primer ingreso termina cuando la persona elige su contraseña y registra su aplicación de autenticación.',
  'owner.mfa.yes': 'Segundo factor registrado',
  'owner.mfa.no': 'Sin segundo factor',
  'owner.column.actions': 'Acciones',
  'owner.edit': 'Editar',
  'owner.edit.for': 'Editar a {name}',
  'owner.edit.title': 'Editar rectoría',
  'owner.edit.emailHelp':
    'El correo es el usuario de acceso y no se puede cambiar. Si está mal, invite otra rectoría con el correo correcto y elimine esta.',
  'owner.edit.saved': 'Datos de la rectoría guardados.',
  'owner.remove': 'Eliminar',
  'owner.remove.for': 'Eliminar a {name}',
  'owner.remove.title': 'Eliminar rectoría',
  'owner.remove.body':
    '{name} ({email}) dejará de poder entrar a la aplicación del colegio y saldrá de la lista. Lo que hizo en el colegio se conserva. El correo queda libre para invitarlo de nuevo.',
  'owner.remove.last': `Es la única rectoría del colegio. Hasta que invite otra, nadie del colegio podrá administrar usuarios ni permisos; el equipo ${PRODUCT_NAME} puede entrar como ${PRODUCT_NAME}.`,
  'owner.remove.done': '{name} ya no es rectoría del colegio.',
  'owner.field.email': 'Correo de la rectoría',
  'owner.field.email.help':
    'Recibirá una contraseña temporal por correo y deberá cambiarla en su primer ingreso.',
  'owner.field.givenName': 'Nombres',
  'owner.field.familyName': 'Apellidos',
  'owner.created.title': 'Rectoría invitada',
  'owner.created': 'Invitación enviada a {email}. La contraseña temporal llegó por correo.',
  'wizard.title': 'Nuevo colegio',
  'wizard.stepOf': 'Paso {step} de 3',
  'wizard.step.school': 'Colegio',
  'wizard.step.contract': 'Contrato',
  'wizard.step.owner': 'Rectoría',
  'wizard.step.done': 'Listo',
  'wizard.school.intro': 'Los datos básicos. Lo demás se completa desde la aplicación del colegio.',
  'wizard.contract.intro':
    'Las condiciones comerciales acordadas con {tenant}. Todo se puede cambiar después.',
  'wizard.owner.intro': 'La persona que administrará {tenant}. Recibirá su acceso por correo.',
  'wizard.next': 'Guardar y continuar',
  'wizard.skipContract': 'Sin contrato por ahora',
  'wizard.done.title': '{tenant} está listo',
  'wizard.done.body':
    'El colegio, su contrato y la rectoría quedaron creados. La rectoría recibió su contraseña temporal por correo.',
  'wizard.done.noContract':
    'Quedó sin contrato: créelo desde la ficha del colegio antes de facturar.',
  'wizard.done.view': 'Ver colegio',
  'actAs.title': `Entrar como ${PRODUCT_NAME}`,
  'actAs.body': `Abrirá la aplicación de {tenant} con su identidad de ${PRODUCT_NAME} durante una hora. Todo lo que haga queda en la auditoría del colegio con su nombre.`,
  'actAs.reason': 'Motivo',
  'actAs.reason.help':
    'Queda en la auditoría del colegio. Por ejemplo: "Soporte de onboarding, importación de estudiantes".',
  'actAs.open': 'Abrir el colegio',
  'actAs.opened': 'Se abrió {tenant} en otra pestaña.',
  'team.title': `Equipo ${PRODUCT_NAME}`,
  'team.add': 'Agregar persona',
  'team.caption': `Personas del equipo ${PRODUCT_NAME}`,
  'team.empty': 'Aún no hay más personas en el equipo.',
  'team.column.person': 'Persona',
  'team.column.role': 'Rol',
  'team.column.status': 'Estado',
  'team.column.created': 'Desde',
  'team.column.mfa': 'Segundo factor',
  'team.resetMfa': 'Restablecer MFA',
  'team.mfaReset': 'Se restableció el segundo factor de {email}; lo activará de nuevo al ingresar.',
  'team.role.STAFF_ADMIN': 'Administración',
  'team.role.SUPER_ADMIN': 'Super administración',
  'team.role.help':
    'Super administración puede crear otras cuentas con ese rol; administración hace todo lo demás.',
  'team.created': 'Cuenta creada. La contraseña temporal llegó por correo.',
  'team.field.email': 'Correo',
  'team.field.role': 'Rol',
  'team.field.givenName': 'Nombres',
  'team.field.familyName': 'Apellidos',
  'nav.contacts': 'Contactos',
  'contacts.title': 'Contactos',
  'contacts.caption': 'Solicitudes desde la página web',
  'contacts.empty.title': 'Sin solicitudes',
  'contacts.empty.body': 'Los mensajes del formulario de contacto de la página aparecerán aquí.',
  'contacts.column.who': 'Quién',
  'contacts.column.school': 'Colegio',
  'contacts.column.message': 'Mensaje',
  'contacts.column.when': 'Recibido',
  'entity.error.title': 'No se pudo cargar la lista',
} as const;
